// extracted by mini-css-extract-plugin
module.exports = {"spacingXxs":".5rem","spacingXs":".75rem","spacingS":"1rem","spacingM":"1.5rem","spacingL":"2rem","spacingXl":"2.5rem"};